import { Endpoint } from "./Endpoint";
import {
    INACTIVE_ENDPOINT, ACTIVE_ENDPOINT, ACTIVE_CONNECTING_LINES, INACTIVE_CONNECTING_LINES
} from "../cell/grid-cell.config";
import {
    createNestedCircle, drawArrowInsideCircle, calculateLineSegmentMidpoint, drawConnectingLine, drawMiddleCircleConnectingLine, filterArrowCellCorners
} from "../components.utils";

export class StartEndpoint extends Endpoint {
    arrowStroke = "#FFFFFF";

    arrowLineWidth = 1.5;

    arrowHeadPos;

    showArrowCorners;

    constructor(layout, state, ctx) {
        super(layout, state, ctx);
    }

    draw() {
        const styles = this.state.selected ? ACTIVE_CONNECTING_LINES : INACTIVE_CONNECTING_LINES;
        const from = { x: this.layout.x, y: this.layout.y };
        const to = { x: this.layout.toX, y: this.layout.toY };
        this.showArrowCorners = false;
        if (to.x && to.y) {
            const midPoint = calculateLineSegmentMidpoint(from, to);
            /** Draw from circle */
            const circlesRadius = [this.layout.radius, this.layout.radius / 2.5];
            const circlesFills = this.state.selected ? ACTIVE_ENDPOINT : INACTIVE_ENDPOINT;
            createNestedCircle(from.x, from.y, circlesRadius, circlesFills, this.ctx);
            /** Draw connecting line */
            drawConnectingLine(from, to, styles, this.ctx);
            /** Draw middle line circle */
            const middleLineFillStyle = circlesFills.fillStyleFirst;
            const midPointRadius = 3;
            drawMiddleCircleConnectingLine(midPoint, midPointRadius, middleLineFillStyle, this.ctx);
            this.showArrowCorners = true;
        }
        const circlesRadius = [this.layout.radius];
        const circlesFills = this.state.selected ? ACTIVE_ENDPOINT : INACTIVE_ENDPOINT;
        this.arrowHeadPos = to.x && to.y ? to : from;
        this.arrowHeadPos.radius = this.layout.radius;

        if (filterArrowCellCorners(this.showArrowCorners, this.layout.dir)) {
            createNestedCircle(this.arrowHeadPos.x, this.arrowHeadPos.y, circlesRadius, circlesFills, this.ctx);
            drawArrowInsideCircle(this.arrowHeadPos.x, this.arrowHeadPos.y, circlesRadius, { stroke: this.arrowStroke, lineWidth: this.arrowLineWidth }, this.layout.dir, this.ctx);
        }
        this.state.drawed = true;
    }

    update(layout, state) {
        super.update(layout, state);
    }
}
